<template>
    <div class="version-registry-update-component">
        <div class="title-block">
            <div class="title-block__title">Реестр версий</div>
            <a :href="route_create_page" class="title-block__btn btn-add btn-primary btn">Добавить версию</a>
        </div>

        <div class="version-registry-update-component-table-ctrls mb-4">
            <div style="max-width: 300px;" class="filter-table__input-wrap search-control">
                <input @keyup.enter="onSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск по номеру или описанию версии ">
                <button @click="onSearch()" class="search-control__input-btn reset-btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
                    </svg>
                </button>
            </div>

            <filter-component :filters="filter" @filterApplied="handleFilterData"/>
        </div>

        <table class="service-table table align-middle">
            <thead>
            <tr>
                <th class="col-header" scope="col" v-for="(elem, index) in thead" :key="index">
                    <div style="display: flex; gap: 4px; align-items: center; justify-content: center;" class="th-inner sortable asc">
                        <span style="width: 95%;">{{ elem }}</span>
                        <div class="dropdown">
                            <svg v-if="['Версия', 'Тип устройства', 'ОС', 'Дата изменения', 'Дата выхода'].includes(elem)" @click="toggleDropdown(index)"
                                 style="cursor: pointer;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 7.5L10 12.5L15 7.5" stroke="#575F6E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <div class="dropdown-menu" :class="{ 'show': dropdownVisible[index] }">
                                <a class="dropdown-item" href="#" @click.prevent="sortBy('asc', elem)">По возрастанию</a>
                                <a class="dropdown-item" href="#" @click.prevent="sortBy('desc', elem)">По убыванию</a>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in tbody" :key="row.id">
                <td>{{ row.tbody.full_version }}</td>
                <td ref="description">{{ row.tbody.description }}</td>
                <td>{{ row.tbody.created_at }}</td>
                <td>{{ row.tbody.updated_at }}</td>
                <td>{{ row.tbody.device_type }}</td>
                <td>{{ row.tbody.device_software_type }}</td>
                <td>
                    <div style="display: flex; gap: 12px;">
                        <div class="table-popup__btn" @click="showDevicesModal(row.tbody.compatible_devices)">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 6.66732V4.16732C15 3.9463 14.9122 3.73434 14.7559 3.57806C14.5996 3.42178 14.3877 3.33398 14.1667 3.33398H3.33333C3.11232 3.33398 2.90036 3.42178 2.74408 3.57806C2.5878 3.73434 2.5 3.9463 2.5 4.16732V14.1673C2.5 14.3883 2.5878 14.6003 2.74408 14.7566C2.90036 14.9129 3.11232 15.0007 3.33333 15.0007H10.8333M13.3333 7.50065H15M10.8333 7.50065C10.8333 7.27964 10.9211 7.06768 11.0774 6.9114C11.2337 6.75512 11.4457 6.66732 11.6667 6.66732H16.6667C16.8877 6.66732 17.0996 6.75512 17.2559 6.9114C17.4122 7.06768 17.5 7.27964 17.5 7.50065V15.834C17.5 16.055 17.4122 16.267 17.2559 16.4232C17.0996 16.5795 16.8877 16.6673 16.6667 16.6673H11.6667C11.4457 16.6673 11.2337 16.5795 11.0774 16.4232C10.9211 16.267 10.8333 16.055 10.8333 15.834V7.50065Z" stroke="#0678F4" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>{{ row.tbody.compatible_devices_count }}</span>
                        </div>
                    </div>
                </td>
                <td class="text-xl-center">
                    <div class="version-column">
                        <span><input class="form-check-input" type="checkbox" :checked="row.tbody.is_required" disabled></span>
                        <span v-if="!row.tbody.is_required">Актуальна до включительно {{ row.tbody.expiration_date }}</span>
                    </div>
                </td>
                <td class="text-xl-center">
                    <div class="version-column">
                        <span><input class="form-check-input" type="checkbox" :checked="row.tbody.is_hotfix" disabled></span>
                    </div>
                </td>
                <td>{{ row.tbody.client }}</td>
                <td>{{ row.tbody.brand }}</td>
                <td><a class="text-decoration-none" :href="cdn_url + row.tbody.file_path">{{ row.tbody.file_name }}</a></td>
                <td>{{ row.tbody.os }}</td>
                <td>
                    <div class="table-action-buttons">
                        <!--							<button class="table-action table-action_status_history m-auto align-middle" @click="showHistoryModal" title="История"></button>-->
                        <button v-if="row.tbody.access_edit" @click="editVersion(row.id)" class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>
                        <button v-if="row.tbody.access_edit" @click="destroyVersion(row.id)" class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <DeviceQuantityModal
            v-if="devicesModal"
            :modalTitle="'Количество устройств'"
            :devices="devices"
            @closeModal="closeDevicesModal"
        />

        <ChangeHistoryModal
            v-if="historyModal"
            :modalTitle="'История изменений'"
            :history="history"
            @closeModal="closeHistoryModal"
        />
    </div>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import ChangeHistoryModal from '../../../../modals/ChangeHistoryModal.vue';
import DeviceQuantityModal from '../../../../modals/DeviceQuantityModal.vue';
import PaginationElement from '../../../../elements/PaginationElement.vue';
import DeviceSoftwareVersion from '../../../../models/AutomaticUpdateDevices/DeviceSoftwareVersion';
import ChangePage from '../../../../helpers/ChangePage';
import { dateFormat } from '../../../../utilites';

import { mapState } from 'vuex/dist/vuex.cjs.js';
import axios from "axios";

export default {
    name: 'VersionRegistryComponent',
    props: {
        route_list: String,
        route_edit: String,
        route_delete: String,
        route_create_page: String,
        route_brands_list: String,
        route_get_names_devices_types: String,
        route_operating_systems: String,
        route_clients: String,
        route_versions_types: String,
        route_destroy: String,
        route_update: String,
        cdn_url: String,
        current_page: {
            type: Number,
            default: 1
        },
    },

    components: {
        DeviceQuantityModal,
        ChangeHistoryModal,
        PaginationElement,
    },

    emits: ['selectRow', 'closeModal'],

    data() {
        return {
            version: new DeviceSoftwareVersion({
                route_list: this.route_list,
                route_delete: this.route_delete,
                route_operating_systems: this.route_operating_systems,
                route_client_search: this.route_clients,
                route_versions_types: this.route_versions_types
            }),
            brand: null,
            brands: [],
            selectedBrand: null,

            client: null,
            clients: [],
            selectedClient: null,

            deviceType: null,
            deviceTypes: [],
            selectedDeviceType: null,

            software: null,
            softwareList: [],
            selectedSoftware: null,

            versionType: null,
            versionTypes: [],
            selectedVersionType: null,

            date: null,

            thead: [
                'Версия',
                'Описание',
                'Дата выхода',
                'Дата изменения',
                'Тип устройства',
                'Тип обновления',
                'Количество устройств',
                'Обязательная версия',
                'Оперативное исправление',
                'Клиент',
                'Бренд',
                'Файл',
                'ОС',
                'Действия'
            ],
            tbody: [],

            search: null,

            columnMap: {
                'Версия': 'number',
                'Тип устройства': 'device_type_id',
                'ОС': 'device_operating_system_id',
                'Дата изменения': 'updated_at',
                'Дата выхода': 'date',
                'Тип Версии': 'device_version_type_id'
            },
            currentSortColumn: '',
            currentSortOrder: '',
            dropdownVisible: Array(12).fill(false),

            selectedRows: [],
            selectAll: false,

            devicesModal: false,
            devices: [],

            historyModal: false,
            history: [
                {id: 1, date: '12.12.2024', time: '12:24', user: 'user@d-services.ru', action: 'XXXX'},
            ],

            count: 1,
            limit: 30,
            page: 1,
        }
    },

    computed: {
        ...mapState('filterComponent', ['filterState']),

        filter() {
            return [
                {
                    type: 'select',
                    name: 'Тип устройства',
                    model: this.deviceType,
                    options: this.deviceTypes
                },
                {
                    type: 'select',
                    name: 'ОС',
                    model: this.software,
                    options: this.softwareList
                },
                {
                    type: 'select',
                    name: 'Бренд',
                    model: this.brand,
                    options: this.brands
                },
                {
                    type: 'select',
                    name: 'Клиент',
                    model: this.client,
                    options: this.clients
                },
                {
                    type: 'select',
                    name: 'Тип версии',
                    model: this.versionType,
                    options: this.versionTypes
                },
                {
                    type: 'date',
                    name: 'Дата выхода',
                    model: null,
                },
            ]
        }
    },

    methods: {
        dateFormat,
        sortBy(order, column) {
            this.currentSortColumn = this.columnMap[column];
            this.currentSortOrder = order;
            this.loadTable();
        },
        loadTable: async function () {
            let response = await this.version.loadTable(
                this.page,
                this.limit,
                this.search,
                this.selectedBrand,
                this.selectedClient,
                this.selectedDeviceType,
                this.selectedSoftware,
                this.selectedVersionType,
                this.date,
                this.currentSortColumn,
                this.currentSortOrder
            );
            this.tbody = response.tbody;

            this.$nextTick(() => {
                this.checkDescriptionLength();
            })

            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        toggleDropdown: function (index) {
            setTimeout(() => {
                this.dropdownVisible = this.dropdownVisible.map((visible, i) => (i === index ? !visible : false));
            }, 1)
        },
        closeDropdown(event) {
            let clickOutside = event.target.className !== 'dropdown-item';
            let dropDownOpenned = document.querySelector('.show') !== null;
            if (dropDownOpenned && clickOutside) {
                this.dropdownVisible = this.dropdownVisible.map(() => false);
            }
        },
        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedRows = this.tbody.map(row => row.id);
            } else {
                this.selectedRows = [];
            }
        },
        showDevicesModal($devices) {
            this.devicesModal = true;
            this.devices = $devices;
        },
        closeDevicesModal() {
            this.devicesModal = false;
        },
        showHistoryModal() {
            this.historyModal = true;
        },
        closeHistoryModal() {
            this.historyModal = false;
        },
        getBrands: async function () {
            let data = await axios.get(this.route_brands_list);
            this.brands = data.data.items;
        },
        getDevicesTypesName: async function () {
            let data = await axios.get(this.route_get_names_devices_types);
            let deviceTypesData = data.data;

            for (const key in deviceTypesData) {
                this.deviceTypes[key] = {
                    id: deviceTypesData[key].id,
                    name: deviceTypesData[key].name
                }
            }
        },
        onSearch: async function () {
            this.page = 1;
            await this.loadTable()
        },
        pageChange: async function (page) {
            this.page = page;
            await this.loadTable();
        },
        destroyVersion: async function(id) {
            let confirmDestroy = confirm('Вы уверены что хотите удалить запись?');

            if(!confirmDestroy) {
                return;
            }

            if (confirmDestroy) {
                await axios.delete(this.route_destroy, {
                    params: {
                        id: id
                    }
                }).then(this.loadTable)
            }
        },
        editVersion: async function (id) {
            location.href = this.route_edit.replace(0, id)
        },
        getOperatingSystems: async function () {
            try {
                const response = await axios.get(this.route_operating_systems);
                this.softwareList = response.data.data;
            } catch (error) {
                console.error('Error load operating systems:', error);
            }
        },
        getClients: async function () {
            let clients = await this.version.clients();
            this.clients = clients.items;
        },
        getVersionsTypes: async function () {
            let types = await axios.get(this.route_versions_types);
            this.versionTypes = types.data.data;
        },
        handleFilterData(data) {
            this.selectedBrand = data.selectedBrand ?? null;
            this.selectedClient = data.selectedClient ?? null;
            this.selectedDeviceType = data.selectedDeviceType ?? null;
            this.selectedSoftware = data.selectedSoftware ?? null;
            this.selectedVersionType = data.selectedVersionType ?? null;
            this.date = data.date ?? null;

            this.loadTable();
        },
        checkDescriptionLength() {
            const cells = this.$refs.description;
            if (cells) {
                cells.forEach(cell => {
                    if (cell.innerText.length >= 80) {
                        cell.title = cell.innerText;
                        cell.innerText = cell.innerText.slice(0, 80) + "…";
                        cell.style.cursor = 'help';
                    }
                });
            }
        }
    },
    watch : {
        search: {
            handler(newValue) {
                if (newValue === '') {
                    this.loadTable();
                }
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.closeDropdown);
        this.loadTable();
        this.getDevicesTypesName();
        this.getBrands();
        this.getOperatingSystems();
        this.getClients();
        this.getVersionsTypes();
    }
}
</script>

<style scoped lang="scss">
.title-block {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}

.page-label {
    font-size: 18px;
    font-weight: 600;
}

.version-registry-update-component-table-ctrls {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
}

.v-selects {
    display: flex;
    flex-direction: row;
    gap: 20px;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-item {
    font-size: 14px;
}

.dropdown-menu {
    padding: 0;
    position: absolute;
    min-width: 160px;
    border-radius: 5px;
    border: none;
    box-shadow: 0px 4px 16px 0px rgba(100, 100, 100, 0.2);
    z-index: 1;
}

.dropdown-menu a {
    color: black;
    padding: 8px 12px;
    text-decoration: none;
    display: block;
}

.dropdown-menu a:hover {
    background-color: #F1F7FF;
}

.table-action-buttons {
    display: flex;
    gap: 8px;
}

.col-header {
    font-size: 14px;
    font-weight: 600;
    color: #575F6E;
}

.table-popup {
    &__btn {
        display: flex;
        gap: 6px;
        background-color: #F1F6FF;
        border-radius: 4px;
        padding: 4px 6px;
        cursor: pointer;
    }
    &__check {
        @extend .table-popup__btn;
        background-color: white;
        cursor: default;
    }
}

.dp__input_wrap input{
    padding-top: 5px;
    padding-right: 12px !important;
    border: none;
    box-shadow: none;
    outline: none;
    max-width: 115px;
    &::placeholder {
        font-weight: 600;
        font-size: 14px;
        color: #000000;
        text-align: center;
    }
}

.version-column {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
</style>
